/**
 * 站点设置「免刷新」通道
 *
 * 后台保存完（皮套 / 指针）喊一嗓子，正在浏览前台页面的那个标签页立刻重新拉设置并应用，
 * 不用主人手动刷新。手段：
 *   1) localStorage 写一个版本号 —— 其它标签页会收到 storage 事件（同源、跨标签）
 *   2) BroadcastChannel —— 更现代，storage 事件在某些浏览器/场景不灵时顶上
 *   3) 切回前台时（visibilitychange）再对一次 —— 兜底
 */
export const SETTINGS_REV_KEY = 'dsh-settings-rev';
export const SETTINGS_CHANNEL = 'dsh-settings';

/** 后台保存后调用 */
export function broadcastSettingsChanged() {
  try {
    localStorage.setItem(SETTINGS_REV_KEY, String(Date.now()));
  } catch (e) {}
  try {
    if (window.BroadcastChannel) {
      const bc = new BroadcastChannel(SETTINGS_CHANNEL);
      bc.postMessage({ type: 'settings-changed', at: Date.now() });
      bc.close();
    }
  } catch (e) {}
}

/** 前台订阅：返回取消订阅的函数 */
export function onSettingsChanged(fn) {
  const onStorage = (e) => {
    // e 为 null 时是手动触发；否则只看我们这个 key
    if (!e || e.key === SETTINGS_REV_KEY) fn();
  };
  window.addEventListener('storage', onStorage);

  let bc = null;
  const onMsg = (ev) => {
    if (ev && ev.data && ev.data.type === 'settings-changed') fn();
  };
  try {
    if (window.BroadcastChannel) {
      bc = new BroadcastChannel(SETTINGS_CHANNEL);
      bc.addEventListener('message', onMsg);
    }
  } catch (e) {}

  const onVisible = () => {
    if (document.visibilityState === 'visible') fn();
  };
  document.addEventListener('visibilitychange', onVisible);

  return () => {
    window.removeEventListener('storage', onStorage);
    document.removeEventListener('visibilitychange', onVisible);
    if (bc) {
      try { bc.removeEventListener('message', onMsg); bc.close(); } catch (e) {}
    }
  };
}

/** 拉当前站点的最新设置（绕开缓存） */
export async function fetchSiteSetting() {
  try {
    const res = await fetch('/adminapi/setting/list?_=' + Date.now(), { cache: 'no-store' });
    const d = await res.json();
    return (d && d.results && d.results[0]) || {};
  } catch (e) {
    // 网络抖动时退回启动时那份，别让页面白屏
    const boot = (window.appSettings && window.appSettings.results && window.appSettings.results[0]) || null;
    return boot || {};
  }
}

/** 把后端存的 JSON 字符串安全地解成数组 */
export function parsePicks(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.slice();
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : [];
  } catch (e) {
    return [];
  }
}

/** 随机取一个（多选时每次刷新随机出现） */
export function pickRandom(list) {
  if (!list || !list.length) return '';
  return list[Math.floor(Math.random() * list.length)];
}

export default { broadcastSettingsChanged, onSettingsChanged, fetchSiteSetting, parsePicks, pickRandom };
